import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { getSubCategory } from 'common/ducks/categories';
import PricingDifferentiators from 'marketing/components/pricing_differentiators';

const mapStateToProps = (state, { subcatId }) => {
  const { categories } = state;
  const subCategory = subcatId? getSubCategory(categories, subcatId) : null;

  return {
    subCategory
  };
}

export default connect(mapStateToProps)(PricingDifferentiators);
